module.exports = __webpack_public_path__ + "5e3d422189798eb6e2914121c1263c10.svg";